var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopBlock',{attrs:{"topData":_vm.topData}}),_c('div',{staticClass:"center favorite-box"},[(_vm.getFavoriteList)?_c('OurProjectsBox',{attrs:{"projectList":_vm.getFavoriteList}}):_c('p',{staticClass:"none-projects text"},[_vm._v("You haven't selected any project yet")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }